export default __webpack_public_path__ + "static/media/NU.e10d5568.svg";